module.exports = __webpack_public_path__ + "img/lora.d3ce66cd.png";